import supabase from '../supabaseClient';
import { notifyCommunityCreditsChanged } from './communityCreditsEvents';

/**
 * Consume one community credit via the consume_game_credit edge function.
 * Uses fetch so non-2xx responses still return JSON { success, error, remainingCredits }.
 */
export async function consumeGameCredit(matchId) {
  const trimmedMatchId = String(matchId || '').trim();
  if (!trimmedMatchId) {
    throw new Error('Match ID is required to consume a credit.');
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_KEY;
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase is not configured.');
  }

  const { data: { session } } = await supabase.auth.getSession();
  const accessToken = session?.access_token;
  if (!accessToken) {
    throw new Error('You must be signed in to create a Statbox game.');
  }

  const response = await fetch(`${supabaseUrl}/functions/v1/consume_game_credit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: supabaseAnonKey,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ matchId: trimmedMatchId }),
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok || !payload?.success) {
    const message =
      payload?.error ||
      (typeof payload?.message === 'string' ? payload.message : null) ||
      `Failed to consume credit (${response.status})`;
    throw new Error(message);
  }

  const remainingCredits =
    typeof payload.remainingCredits === 'number' ? payload.remainingCredits : null;
  notifyCommunityCreditsChanged(remainingCredits);

  return {
    remainingCredits,
    message: payload.message || null,
  };
}
